import { getItemVersion } from "../../api/content/itemsApi";
import { SharedReads } from "../../shared/loading/sharedReads";

const MAXIMUM_NAMES = 256;

/** Owned by one signed-in session, project and language. Failed reads can be tried again. */
export class ItemNameCache {
  private readonly names = new SharedReads<string>(MAXIMUM_NAMES);

  constructor(
    readonly sessionKey: string | null,
    readonly projectId: string | null,
    private readonly load: (reference: string) => Promise<string> = (reference) => getItemVersion(reference).then((item) => item.name),
    readonly language?: string,
  ) {}

  nameOf(reference: string): Promise<string | null> {
    if (this.sessionKey === null || this.projectId === null) {
      return Promise.resolve(null);
    }
    return this.names.read(reference, () => this.load(reference)).catch(() => null);
  }

  clear(): void {
    this.names.clear();
  }
}
